import { useFormContext } from 'react-hook-form';
import { Title } from '@optimus-web/core';
import { SectionList, useTimeService } from '@mews-commander/ui';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { mapRoutingRuleToRoutingRuleDetail } from '../../../RoutingRuleDetailContainer/utils/mapRoutingRuleToRoutingRuleDetail';
import { useServicesSuspenseQuery } from '../itemsAndConditions/queries';
import { RoutingRuleFormValues } from '../../../../schemas';
import { useMapFormValuesToRoutingRule } from './hooks';

export const RoutingRuleSummary = () => {
    const { getValues } = useFormContext<RoutingRuleFormValues>();
    const formValues = getValues();
    const routingRuleResult = useMapFormValuesToRoutingRule(formValues);
    const timeService = useTimeService();
    const { data: allServices } = useServicesSuspenseQuery();
    const granularRoutingRulesConditionsExtensionEnabled = useFeatureFlag(
        FeatureFlag.granularRoutingRulesConditionsExtensionEnabled
    );

    const { sections } = mapRoutingRuleToRoutingRuleDetail({
        routingRuleResult,
        additionalData: { allServices },
        timeService,
        aggregateItems: true,
        granularRoutingRulesConditionsExtensionEnabled,
    });
    return (
        <>
            <Title level={2}>{formValues.timing.name}</Title>
            <SectionList sections={sections} />
        </>
    );
};
